export const getAvatarUrl = (url: string | undefined | null) => {
  if (!url) return '';
  if (url.startsWith('http')) {
    return url;
  }
  return process.env.REACT_APP_GITLABURL + url;
};
